import { WRAPPED_SOL_MINT } from "@bridgesplit/utils";

export const ALL_COLLATERAL_VALUE = [];

//  Since custodian metadata doesn't have direct presets, we use USDC as a placeholder
export const ALL_PRESET_COLLATERAL_VALUE = WRAPPED_SOL_MINT;
